import styled from 'styled-components';

import AmexFilledIcon from '@/assets/amex-filled.svg?react';
import ApplePayIcon from '@/assets/apple-pay.svg?react';
import DiscoverFilledIcon from '@/assets/discover-filled.svg?react';
import GooglePayIcon from '@/assets/google-pay.svg?react';
import MastercardFilledIcon from '@/assets/mastercard-filled.svg?react';
import VisaFilledIcon from '@/assets/visa-filled.svg?react';

const LabelStyles = styled.div`
  border-radius: 6px;
  background: #000;
  padding: 8px;
  font-size: 0;
  line-height: 0;
`;

export const ApplePayLabel = () => {
  return (
    <LabelStyles>
      <ApplePayIcon />
    </LabelStyles>
  );
};

export const GooglePayLabel = () => {
  return (
    <LabelStyles>
      <GooglePayIcon />
    </LabelStyles>
  );
};

const CreditCardIconsStyles = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  svg {
    width: 35px;
    height: 20px;
  }
`;

export const CreditCardLabel = () => {
  return (
    <CreditCardIconsStyles>
      <VisaFilledIcon />
      <MastercardFilledIcon />
      <DiscoverFilledIcon />
      <AmexFilledIcon />
    </CreditCardIconsStyles>
  );
};
